import { render } from "./About.vue?vue&type=template&id=1b187615"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=1b187615&lang=scss"
script.render = render

export default script